import { getExamineeAxios, useAxios } from "@/utils/axios";
import { useMemo } from "react";

export const REGISTRATION_METHOD_SCAN = 0;
export const REGISTRATION_METHOD_INPUT = 1;

export const REGISTRATION_METHOD_LIST = [
  REGISTRATION_METHOD_SCAN,
  REGISTRATION_METHOD_INPUT,
] as const;
export type RegistrationMethodType = (typeof REGISTRATION_METHOD_LIST)[number];

export function postDeviceIdRegistration(
  deviceId: string,
  registrationMethod: number,
  sleepCheckUpId: string,
  currentPath: string
) {
  const param = {
    device_id: deviceId,
    registration_method: registrationMethod,
    sleep_checkup_info: sleepCheckUpId,
  };

  return getExamineeAxios(currentPath).post(
    `/api/device_id_registration/`,
    param
  );
}

export function useRingIdRegistrationAPI() {
  const axios = useAxios();
  return useMemo(
    () => ({
      async post({
        ringId,
        registrationMethod,
        sleepCheckupUuid,
      }: {
        ringId: string;
        registrationMethod: RegistrationMethodType;
        sleepCheckupUuid: string;
      }) {
        return axios.post(`/api/ring_id_registration/`, {
          ring_id: ringId,
          registration_method: registrationMethod,
          sleep_checkup_info: sleepCheckupUuid,
        });
      },
    }),
    [axios]
  );
}
